import { cx } from "../lib/cx.js";
import { Spinner } from "./ui/States.js";

/** Isotipo: escudo + lupa (mismo dibujo que el favicon). */
export function Logo({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" className={cx("shrink-0", className ?? "size-7")}>
      <rect width="32" height="32" rx="7" fill="var(--accent)" />
      <path
        d="M16 6.5 8 9.6v6.1c0 4.9 3.4 8.6 8 9.8 4.6-1.2 8-4.9 8-9.8V9.6z"
        fill="none"
        stroke="var(--accent-fg)"
        strokeWidth="2.2"
        strokeLinejoin="round"
      />
      <circle cx="15.2" cy="15" r="3.4" fill="none" stroke="var(--accent-fg)" strokeWidth="2" />
      <path d="m17.7 17.5 2.6 2.6" stroke="var(--accent-fg)" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  );
}

export function Wordmark({ className }: { className?: string }) {
  return (
    <span className={cx("inline-flex items-center gap-2", className)}>
      <Logo />
      <span className="text-[15px] font-bold tracking-[0.14em] text-fg">SENTINEL</span>
    </span>
  );
}

/** Pantalla de carga inicial (mientras se valida la sesión o llega un módulo). */
export function Splash({ label = "Cargando SENTINEL…" }: { label?: string }) {
  return (
    <div role="status" className="flex min-h-dvh flex-col items-center justify-center gap-4 text-muted">
      <Wordmark />
      <span className="inline-flex items-center gap-2 text-sm">
        <Spinner />
        {label}
      </span>
    </div>
  );
}
